import { z } from 'zod';
import { makeDATOriginDataSchema } from './datOriginData';

export const makeStandardPricingDataSchema = () => {
  return z.object({
    maxPrice: z.number().optional(),
    targetPrice: z.number().optional(),
    startingPrice: z.number().optional(),
    marketCarrierRate: z.number().optional(),
    totalCharge: z
      .number()
      .optional() /* TODO(farzaan): remove this, movements should not have customer pricing info
    need to ensure all TMS integrations put this in the order, and run the according migration */,
    datOriginData: makeDATOriginDataSchema().optional(),
  });
};
const StandardPricingDataSchema = makeStandardPricingDataSchema();
export type StandardPricingData = z.infer<typeof StandardPricingDataSchema>;
